<template>
  <div style="height: 76px !important;">
    <div class="expand-item-container" style="margin-left: 35px; position: absolute;">
        <div class="expand-item text500">
          电子处方冻结数量：<span>{{row.inventoryFrozenLists[0].epSaleFrozenNum}}</span>
        </div>
        <div class="expand-item text500">
          退货审批冻结数量：{{row.inventoryFrozenLists[0].supplierRefundFrozenNum}}
        </div>
        <div class="expand-item text500">
          药品召回冻结数量：{{row.inventoryFrozenLists[0].inventoryRecallFrozenNum}}
        </div>
        <div class="expand-item text500">
          盘损审批冻结数量：{{row.inventoryFrozenLists[0].inventoryCheckLoseFrozenNum}}
        </div>
        <div class="expand-item text500">
          库存养护冻结数量：{{row.inventoryFrozenLists[0].inventoryCuringFrozenNum}}
        </div>
        <div class="expand-item text500">
          不合格品冻结数量：{{row.inventoryFrozenLists[0].unqualifiedFrozenNum}}
        </div>
        <div class="expand-item text500">
          手动冻结数量：{{row.inventoryFrozenLists[0].manualRecordFrozenNum}}
        </div>
      </div>
      <div class="expand-item-container" style="margin-left: 35px; margin-top: 25px; position: absolute;">
        <div class="expand-item">
          商品类型：{{row.goodsTypeName}}
        </div>
        <div class="expand-item">
          商品状态：{{row.goodsStoreStatus == 1 ? '启用' : '禁用'}}
        </div>
        <div class="expand-item">
          医保编码：{{row.medicalSerialCode}}
        </div>
        <div class="expand-item">
          助记码：{{row.mnemonicCode}}
        </div>
        <div class="expand-item">
          剂型：{{row.dosageForm}}
        </div>
        <div class="expand-item">
          是否DTP：{{row.isDtpStr}}
        </div>
        <div class="expand-item">
          上市许可证持有人：{{row.mah}}
        </div>
        <div class="expand-item">
          产地：{{row.countryOfOrigin}}
        </div>
      </div>
      <div class="expand-item-container" style="margin-left: 35px; margin-top: 50px; position: absolute;">
        <div class="expand-item">
          批准文号/注册证号：{{row.approvalNumber}}
        </div>
        <div class="expand-item">
          来源：{{fromStr}}
        </div>
        <div class="expand-item">
          养护标准：{{row.maintainType == 1 ? '一般养护' : '重点养护'}}
        </div>
        <div class="expand-item">
          成本类型：{{row.payment == 1 ? '普通' : '寄售'}}
        </div>
        <div class="expand-item">
          商品标签：{{row.goodsLabel}}
      </div>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'InventoryInfoExpand',
  props: {
    row: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters([
      'getGoodsOrigin',
      'getNormalGoodsTypes',
    ]),
    fromStr() {
      let purchaseTypeName = '';
      this.getGoodsOrigin.forEach((item) => {
        if (item.value === this.row.purchaseType) {
          purchaseTypeName = item.name;
        }
      });
      return purchaseTypeName;
    },
  },
};
</script>
<style  lang="less" scoped>
  .text500 {
    font-weight: 500;
  }
</style>
